document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initMarquesina();
});

// Red de seguridad: si por lo que sea este script no llega a ejecutarse a tiempo
// en alguna sección (orden de carga, sección añadida desde el editor...), nunca
// debe quedar contenido invisible de forma permanente.
setTimeout(function () {
  document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
    el.classList.add('mt-visible');
  });
}, 2500);

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var dur = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased).toString();
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toString();
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  var wraps = document.querySelectorAll('[data-mt-marquesina]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.mt-marquesina-track');
    if (!track) return;
    if (track.dataset.mtCloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtCloned = 'true';
  });
}
